import PedidoCompraService from "@/services/PedidoCompraService"
import { router } from '@/router'
import helper from '@/helper'
import moment from 'moment'

export const actions = {
    cadastrarPedidoCompra: ({ commit, dispatch }) => {
        commit('setPedidoCompra', {
            id: '',
            ordem_compra: '',
            data_compra: moment().format('YYYY-MM-DD'),
            data_prevista: moment().format('YYYY-MM-DD'),
            desconto: '0,00',
            subtotal : '0,00',
            frete: '0,00',
            total: '0,00',
            fornecedor_id: '',
            transportadora_id: '',
            reponsabilidade_frete: 'CLIENTE',
            quantidade_volume: 0,
            peso_bruto: 0,
            
        }),

        commit('setItensPedidoCompra', [])
        commit('setContato', {})

        router.push({ name: 'pedidoCompraCadastro' })
    },
    listarPedidoCompra: ({ commit }, data) => {
        commit('setOverlay', true)
        PedidoCompraService.listar(data)
            .then(res => {
                commit('setOverlay', false)
                commit('setPerfis', res.data)
                commit('setPedidosCompras', res.data)

            })
            .catch(e => {
                commit('setOverlay', false)
                console.log(e)
            })
    },
    visualizarPedidoCompra: ({ commit, dispatch }, id) => {
        commit('setOverlay', true)
        commit('setItensPedidoCompra', [])

        PedidoCompraService.editar(id)
            .then(res => {
                let data = res.data
                data.frete = helper.formatReal(parseFloat(res.data.frete))
                data.desconto = helper.formatReal(parseFloat(res.data.desconto))
                data.total = helper.formatReal(parseFloat(res.data.total))
                data.subtotal = helper.formatReal(parseFloat(res.data.total + res.data.desconto))
                commit('setContato', res.data.fornecedor)

                data.itens.forEach(e => {
                    let item = {
                        'produto_id': e.produto_id,
                        'descricao': e.descricao,
                        'preco': e.preco,
                        'quantidade': e.quantidade,
                        'total': e.total,
                        'unidade': e.unidade == null ? 'UN' : e.unidade,
                        // 'desconto': e.desconto
                    }
                    commit('addItemPedidoCompra', item)
                });

                commit('setPedidoCompra', data)
                commit('setOverlay', false)
                commit('setModalCadastroOrcamento', true)
            })
            .catch(e => {
                commit('setOverlay', false)
            })
    },

    salvarPedidoCompra: ({ commit, dispatch }, data) => {
        commit('setOverlay', true)
        PedidoCompraService.salvar(data)
            .then(res => {
                commit('setPedidoCompra', {
                    ...res.data,
                    frete: helper.formatReal(parseFloat(res.data.frete)),
                    desconto: helper.formatReal(parseFloat(res.data.desconto)),
                    total: helper.formatReal(parseFloat(res.data.total)),
                    subtotal: helper.formatReal(parseFloat(res.data.total + res.data.desconto)),
                })
                // commit('addPedidoCompra', res.data)
                commit('setOverlay', false)
                commit('snackbarSuccess', 'Pedido de compra cadastrado.')
                router.push({ name: 'pedidoCompraEditar', params: { id: res.data.id } })
            })
            .catch(e => {
                if (e.response.status == 422) {
                    commit('alertError', e.response.data.errors)
                }
                console.log(e)
                commit('setOverlay', false)
                commit('snackbarError', 'Erro ao cadastrar.')
            })
    },
    atualizarPedidoCompra: ({ commit, dispatch }, data) => {
        commit('setOverlay', true)
        PedidoCompraService.atualizar(data)
            .then(res => {
                // dispatch('listarPedidoCompra')
                commit('setOverlay', false)
                commit('snackbarSuccess', 'Pedido de compra atualizado.')
            })
            .catch(e => {
                if (e.response.status == 422) {
                    commit('alertError', e.response.data.errors)
                }
                console.log(e)
                commit('setOverlay', false)
                commit('snackbarError', 'Erro ao atualizar.')
            })
    },
    imprimirPedidoCompra: ({commit, dispatch}, id) => {
        commit('setOverlay', true)
        PedidoCompraService.imprimir(id)
        .then(res => {
            commit('setOverlay', false)
            commit('setModalPrint', res.data.pdf_link)
        })
        .catch(e => {
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao imprimir.')
        })
    },
    enviarEmailPedidoCompra: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        PedidoCompraService.enviarEmail(data)
        .then(res => {
            commit('setOverlay', false)
            commit('snackbarSuccess', 'E-mail enviado.')
        })
        .catch(e => {
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao enviar e-mail');
        })
    },
    excluirPedidoCompra: ({ commit, dispatch }, data) => {
        dispatch('setModalExcluirPedidoCompra', false)
        dispatch('setModalCadastroPedidoCompra', false)
        commit('setOverlay', true)
        PedidoCompraService.excluir(data.id)
            .then(res => {
                router.push({name: 'pedidosCompras'})
                commit('removePedidoCompra', res.data)
                commit('setOverlay', false)
                commit('snackbarError', 'Pedido de compra excluído.')
            })
            .catch(e => {
                commit('snackbarError', 'Erro ao atualizar pedido de compra.')
            })
    },
    setModalCadastroPedidoCompra: ({ commit }, status) => {
        commit('setModalCadastrarPedidoCompra', false)
        setTimeout(() => {
            commit('setModalCadastrarPedidoCompra', status)
        }, 100);
    },
    setModalExcluirPedidoCompra: ({ commit }, status) => {
        commit('setModalExcluirPedidoCompra', false)
        setTimeout(() => {
            commit('setModalExcluirPedidoCompra', status)
        }, 100);
    },
    setModalEnviarEmailPedidoCompra: ({ commit }, status) => {
        commit('setModalEnviarEmailPedidoCompra', false)
        setTimeout(() => {
            commit('setModalEnviarEmailPedidoCompra', status)
        }, 100);
    },
}

export default {}